import { loaderService } from "../../../common/custom-loader/loader-service";
import { ADD_RATE_CARD_ITEM, UPDATE_RATE_CARD, GET_ALL_RATE_CARD_BY_CATEGORY_AND_ITEM_TYPE, ITEM_LIST_BASED_ON_CATEGORY, URN_LIST_BASED_ON_CAT_ITEM, GET_LIST_POSSIBLE_ROUTES, LIST_OF_UNIT_PER_ITEM, CHECK_RATE_CARD_VALIDITY, DELETE_RATE_CARD_BY_ID, FETCHING_BUDGET_APPROVAL_ROLE, PROVIDE_SEEK_CLARIFICATION_RATE_CARD, FETCH_STAKEHOLDER_RATECARD_STATUS, SAVE_RATE_CARD_DRAFT, FETCH_RATE_DRAFT_BY_REQ_NO, DELETE_DRAFT_BY_RQST, FETCH_GROWER_URN_LIST, FETCH_LLE_URN_LIST } from '../../../common/URLs';

import { getLocalStorageItem } from "../../../common/localStorageUtils";
import apiClient from "../../../axios";

export function getItemTypeList(setItemTypeList) {
  loaderService.showLoader();
  apiClient
    .post(ITEM_LIST_BASED_ON_CATEGORY,
      {
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setItemTypeList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function fetchBudgetApprovalRole(setBudgetApprovalRole, approvalBudget) {
  // addedRateCardDetailsArr.map(item => ({ itemRate: item.itemRate.toString() }))
  loaderService.showLoader();
  apiClient
    .post(FETCHING_BUDGET_APPROVAL_ROLE,
      [
        {
          "itemRate": approvalBudget
        }
      ],
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setBudgetApprovalRole(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function addRateCard(setRateCardResponse, finalRateCardDetailsArr, budget) {
  loaderService.showLoader();
  apiClient
    .post(ADD_RATE_CARD_ITEM,
      {
        "getItemList": finalRateCardDetailsArr.map(item => (
          {
            ...item,
            approvalBudget: budget?.budgetApproval,
            finalBudgetApprover: budget?.budgetApproverRole,
            createdName: localStorage.getItem('userName'),
            createdRole: localStorage.getItem('role'),
          }
        ))
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setRateCardResponse(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function provideClarificationRateCard(setRateCardResponse, finalRateCardDetailsArr, budget) {
  loaderService.showLoader();
  apiClient
    .post(PROVIDE_SEEK_CLARIFICATION_RATE_CARD,
      {
        "getItemList": finalRateCardDetailsArr.map(item => (
          {
            ...item,
            approvalBudget: budget?.approvalBudget,
            finalBudgetApprover: budget?.finalBudgetApprover,
            createdName: localStorage.getItem('userName'),
            createdRole: localStorage.getItem('role'),
          }
        ))
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setRateCardResponse(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getUrnsList(setUrnsList, rateCardDetails) {
  loaderService.showLoader();
  apiClient
    .post(URN_LIST_BASED_ON_CAT_ITEM,
      {
        "category": rateCardDetails?.category,
        "itemType": rateCardDetails?.itemType,
        "route": rateCardDetails?.routeType,
        "state": rateCardDetails?.state,
        "district": rateCardDetails?.district,
        "revenueCircle": rateCardDetails?.revenueCircle,
        "validFrom": rateCardDetails?.validFromProceed,
        "validTo": rateCardDetails?.validToProceed,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setUrnsList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getAllRouteDetails(setRoutesList) {
  loaderService.showLoader();
  apiClient
    .post(GET_LIST_POSSIBLE_ROUTES,
      {
        "serviceType": "transporter"
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        },
      }
    )
    .then((response) => {
      setRoutesList(response.data.PossibleRouteDropDown);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getRateUnits(setUnitsList) {
  loaderService.showLoader();
  apiClient
    .post(LIST_OF_UNIT_PER_ITEM,
      {
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setUnitsList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getAllRateCard(selectCategoryAndType, setRateCardDetailsArr) {
  loaderService.showLoader();
  apiClient
    .post(GET_ALL_RATE_CARD_BY_CATEGORY_AND_ITEM_TYPE,
      {
        "category": selectCategoryAndType?.category,
        "itemType": selectCategoryAndType?.itemType
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setRateCardDetailsArr(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function deleteRateCard(item, setEditRateCardResponse) {
  loaderService.showLoader();
  apiClient
    .post(DELETE_RATE_CARD_BY_ID,
      item,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setEditRateCardResponse(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function editRateCard(rateCardDetails, setEditRateCardResponse) {
  loaderService.showLoader();
  apiClient
    .post(UPDATE_RATE_CARD,
      {
        "id": rateCardDetails?.id,
        "vehicleType": rateCardDetails?.vehicleType,
        "sponsorshipFlag": rateCardDetails?.sponsorshipFlag,
        "dbsFlag": rateCardDetails?.dbsFlag,
        "category": rateCardDetails?.category,
        "routeName": rateCardDetails?.routeName,
        "itemType": rateCardDetails?.itemType,
        "urnNumber": rateCardDetails?.urnNumber,
        "landId": rateCardDetails?.landId,
        "vehicleId": rateCardDetails?.vehicleId,
        "itemRate": rateCardDetails?.itemRate,
        "unitPer": rateCardDetails?.unitPer,
        "transporterTableId": rateCardDetails?.transporterTableId,
        "isActive": rateCardDetails?.isActive,
        "createdBy": rateCardDetails?.createdBy,
        "createdOn": rateCardDetails?.createdOn,
        "updatedBy": rateCardDetails?.updatedBy,
        "updatedOn": rateCardDetails?.updatedOn,
        "name": rateCardDetails?.name,
        "state": rateCardDetails?.state,
        "district": rateCardDetails?.district,
        "revenueCircle": rateCardDetails?.revenueCircle,
        "vehicleModel": rateCardDetails?.vehicleModel,
        "vehicleMake": rateCardDetails?.vehicleMake,
        "vehicleMakeModel": rateCardDetails?.vehicleMakeModel,
        "registrationNo": rateCardDetails?.registrationNo,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setEditRateCardResponse(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function rateCardValidity(finalRateCardDetailsArr, setCheckValidityResponse) {
  loaderService.showLoader();
  apiClient
    .post(CHECK_RATE_CARD_VALIDITY,
      finalRateCardDetailsArr,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setCheckValidityResponse(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function saveRateCardDraft(saveRateCardDetailsArr, setSaveDraftResponse, setSaveDraftClick) {
  loaderService.showLoader();
  apiClient
    .post(SAVE_RATE_CARD_DRAFT,
      { "rateCardMasterDraftDto": saveRateCardDetailsArr },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setSaveDraftResponse(response.data);
      setSaveDraftClick(false);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function fetchDraftedRateCard(reqstNo, setWorkFlowRequestDetails) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_RATE_DRAFT_BY_REQ_NO,
      {   "reqstNo": reqstNo },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setWorkFlowRequestDetails(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function deleteDraftRateByReqNo(reqstNo, setDeleteDraftReqResponse) {
  loaderService.showLoader();
  apiClient
    .post(DELETE_DRAFT_BY_RQST,
      {   "reqstNo": reqstNo },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setDeleteDraftReqResponse(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function fetchStakeholderRateCardStatus(urn, setRateCardStatusResponse) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_STAKEHOLDER_RATECARD_STATUS,
      {
        "urnNumber": urn
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setRateCardStatusResponse(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getCategoryUrnList(category, setUrnList) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_LLE_URN_LIST,
      {
        "stakeholderCategory": category
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setUrnList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getGrowerUrnsList(setUrnsList, selectedUrn) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_GROWER_URN_LIST,
      {
        "urn": selectedUrn,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setUrnsList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}